import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { ReactComponent as IconCrossRound } from "../Images/icon_cross_round.svg";
import LayoutModal from "../Layout/LayoutModal";
import "../Styles/component.css";
import "../Styles/fonts.css";
import "../Styles/global.css";
import "../Styles/lists.css";
import { postJson } from "../Utils/apiUtils";

const IssuedGifticonListBox = ({ handleClickX, companyChallengeId }) => {
  const navigate = useNavigate();

  const [page, setPage] = useState(1);
  const offset = 20;

  const [issued_list, setIssued_list] = useState([]);

  const getIssuedGifticonList = async () => {
    try {
      const res = await postJson(
        "/dashboard/gifticonChallenge/getIssuedList",
        { page, offset, companyChallengeId },
        navigate
      );

      if (res.code === 200) {
        setIssued_list(res.data.rows);
      }
    } catch (error) {
      console.error("발급 내역 가져오기 중 에러:", error);
    }
  };

  useEffect(() => {
    getIssuedGifticonList();
  }, []);

  return (
    <Box>
      <div className="hrz-wrapper center">
        <p className="bold-text" style={{ fontSize: "24px" }}>
          발급 내역
        </p>
      </div>
      <div className="hrz-wrapper" style={{ marginTop: "-32px" }}>
        <div style={{ marginLeft: "auto", cursor: "pointer" }}>
          <IconCrossRound onClick={handleClickX} />
        </div>
      </div>

      <div
        className="list_titleBar"
        style={{
          marginTop: "20px",
          width: "740px",
          height: "44px",
          gridTemplateColumns: "100px 200px 220px 220px",
        }}
      >
        <p className="center">NO</p>
        <p className="leftalign">발급 날짜</p>
        <p className="leftalign">닉네임</p>
        <p className="leftalign">상품명</p>
      </div>
      {issued_list.length > 0 ? (
        <div className="scrollView" style={{ height: "529px" }}>
          {issued_list.map((data) => (
            <div
              key={data.rownum}
              className="list_contentBar"
              style={{
                width: "740px",
                gridTemplateColumns: "100px 200px 220px 220px",
              }}
            >
              <p className="center">{data.rownum}</p>
              <p className="leftalign">{data.regTime}</p>
              <p className="leftalign">{data.nickName}</p>
              <p className="leftalign">{data.productName}</p>
            </div>
          ))}
        </div>
      ) : (
        <div
          className="center"
          style={{ height: "529px", color: "#888888", fontSize: "15px" }}
        >
          발급 내역이 없습니다.
        </div>
      )}
      <div></div>
    </Box>
  );
};

const IssuedGifticonList = ({ handleClickX, companyChallengeId }) => {
  return (
    <LayoutModal
      Modal={
        <IssuedGifticonListBox
          handleClickX={handleClickX}
          companyChallengeId={companyChallengeId}
        />
      }
    />
  );
};

const Box = styled.div`
  padding: 30px;
  background-color: #ffffff;
  border-radius: 20px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
`;

export default IssuedGifticonList;
